import TablaConciliacion from "../../../TablaConciliacion";

function TablaVia40Express() {
  return <TablaConciliacion nombreUseCase="VIA40EXPRESS" titulo="VIA 40 EXPRESS" />;
}

export default TablaVia40Express;
